import React from 'react';

export default function TagBadge({ tag, size = 'sm' }) {
  if (!tag) return null;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '3px',
        padding: size === 'lg' ? '3px 10px' : '1px 7px',
        borderRadius: '8px',
        fontSize: size === 'lg' ? '12px' : '10px',
        fontWeight: 700,
        background: tag.color || '#0B1A4A',
        color: '#fff',
        whiteSpace: 'nowrap',
        lineHeight: '1.4',
      }}
    >
      {tag.icono && <span>{tag.icono}</span>}
      {tag.nombre}
    </span>
  );
}
